import { render, staticRenderFns } from "./AddApplicant.vue?vue&type=template&id=10bc1058&scoped=true"
import script from "./AddApplicant.vue?vue&type=script&lang=js"
export * from "./AddApplicant.vue?vue&type=script&lang=js"
import style0 from "./AddApplicant.vue?vue&type=style&index=0&id=10bc1058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bc1058",
  null
  
)

export default component.exports